import styled from 'styled-components';
import { colors, px, fontFamilySize } from '../../../../../contrib/ui';

export const TitleContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: ${px(1)} solid ${colors.greyd8};
  margin-top: ${px(-6)};
  margin-bottom: ${px(20)};
  padding-bottom: ${px(9)};

  .title-tooltip.override {
    ${fontFamilySize('Heavy', 22)}
    color: ${colors.dark};

    text-transform: uppercase;
    margin: 0 !important;
    padding: 0 !important;
    border-bottom: 0 !important;
  }
`;
